import { environment } from '@environment';

export const upsellApi = {
  // eslint-disable-next-line max-len
  air_upsell: `${environment.api.services}/api/travel-proxy-ms/air/upsell/whole-trip?search_id={searchId}&option_id={optionId}&extended_information=true`,
  air_upsell_by_sector: `${environment.api.services}/api/travel-proxy-ms/air/by-sector/upsell`,
  air_option: `${environment.api.netactica}/AirGroupedResults?searchId={searchId}`,
};
